import { render, staticRenderFns } from "./add-company-report-details.vue?vue&type=template&id=33474e86&"
import script from "./add-company-report-details.vue?vue&type=script&lang=js&"
export * from "./add-company-report-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports